import axios from 'axios';

const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('eturizam_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const gate = localStorage.getItem('eturizam_gate');
  if (gate) config.headers['X-Gate-Token'] = gate;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401) {
      if (err.response?.data?.gate) {
        localStorage.removeItem('eturizam_gate');
        window.location.reload();
      } else {
        localStorage.removeItem('eturizam_token');
        localStorage.removeItem('eturizam_user');
      }
    }
    return Promise.reject(err);
  }
);

// Obavijesti sve otvorene stranice da ponovo učitaju podatke nakon mutacije
export const notifyUpdate = () => window.dispatchEvent(new Event('store-updated'));

export default api;
